import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";

// redux
import { useSelector } from "react-redux";

//constants
import { layoutTypes } from "../constants/layout";

// layouts
import NonAuthLayout from "../Layout/NonAuthLayout";
import VerticalLayout from "../Layout/VerticalLayout/index";
import HorizontalLayout from "../Layout/HorizontalLayout/index";
import Error404 from "../Pages/Utility/Error404-Page";
import {
  AuthProtected,
  AccessRoute,
  IsUserLoggedIn,
  AdminProtectedRoutes,
  UserProtectedRoutes,
  QualityManagerProtectedRoutes,
  BatchControlManagerProtectedRoutes,
  ProductionManagerProtectedRoutes,
} from "./AuthProtected";

import {
  userRoutes,
  batchControlManagerRoutes,
  productionManagerRoutes,
  qualityManagerRoutes,
  adminRoutes,
  authProtectedRoutes,
  publicRoutes,
} from "./routes";

import { createSelector } from "reselect";

const getLayout = (layoutType) => {
  let Layout = VerticalLayout;
  switch (layoutType) {
    case layoutTypes.VERTICAL:
      Layout = VerticalLayout;
      break;
    case layoutTypes.HORIZONTAL:
      Layout = HorizontalLayout;
      break;
    default:
      break;
  }
  return Layout;
};

const Index = () => {
  const routepage = createSelector(
    (state) => state.Layout,
    (state) => ({
      layoutType: state.layoutType,
    })
  );
  // Inside your component
  const { layoutType } = useSelector(routepage);

  const Layout = getLayout(layoutType);

  return (
    <Routes>
       <Route>
        {authProtectedRoutes?.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <AuthProtected>
                <Layout>{route.component}</Layout>
              </AuthProtected>
            }
            key={idx}
            exact={true}
          />
        ))}
      </Route> 
      <Route>
        {adminRoutes?.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <AuthProtected>
                <AdminProtectedRoutes>
                  <Layout>{route.component}</Layout>
                </AdminProtectedRoutes>
              </AuthProtected>
            }
            key={idx}
            exact={true}
          />
        ))}
      </Route>
      <Route>
        {userRoutes?.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <AuthProtected>
                <UserProtectedRoutes>
                  <Layout>{route.component}</Layout>
                </UserProtectedRoutes>
              </AuthProtected>
            }
            key={idx}
            exact={true}
          />
        ))}
      </Route>
      <Route>
        {qualityManagerRoutes?.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <AuthProtected>
                <QualityManagerProtectedRoutes>
                  <Layout>{route.component}</Layout>
                </QualityManagerProtectedRoutes>
              </AuthProtected>
            }
            key={idx}
            exact={true}
          />
        ))}
      </Route>
      <Route>
        {batchControlManagerRoutes?.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <AuthProtected>
                <BatchControlManagerProtectedRoutes>
                  <Layout>{route.component}</Layout>
                </BatchControlManagerProtectedRoutes>
              </AuthProtected>
            }
            key={idx}
            exact={true}
          />
        ))}
      </Route>
      <Route>
        {productionManagerRoutes?.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <AuthProtected>
                <ProductionManagerProtectedRoutes>
                  <Layout>{route.component}</Layout>
                </ProductionManagerProtectedRoutes>
              </AuthProtected>
            }
            key={idx}
            exact={true}
          />
        ))}
      </Route>

      <Route>
        {publicRoutes?.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <IsUserLoggedIn>
                <NonAuthLayout>{route.component}</NonAuthLayout>
              </IsUserLoggedIn>
            }
            key={idx}
            exact={true}
          />
        ))}
      </Route>
      {/* Catch-all route for 404 Not Found */}
      <Route path="*" element={<Error404 />} />
    </Routes>
  );
};

export default Index;
